var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 181,
    viewBox: "0 0 181 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 179,
    rx: 89.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 179,
    rx: 89.5,
    stroke: "#0F9D58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.25 63.4166C74.25 54.2083 81.2917 47.1666 90.5 47.1666C99.7084 47.1666 106.75 54.2083 106.75 63.4166V74.25H117.583V63.4166C117.583 48.25 105.667 36.3333 90.5 36.3333C75.3334 36.3333 63.4167 48.25 63.4167 63.4166V74.25H74.25V63.4166ZM98.625 104.042C98.625 99.7083 94.8334 95.9166 90.5 95.9166C86.1667 95.9166 82.375 99.7083 82.375 104.042C82.375 106.208 83.4584 108.375 85.0834 110V117.583C85.0834 120.833 87.25 123 90.5 123C93.75 123 95.9167 120.833 95.9167 117.583V110C97.5417 108.375 98.625 106.208 98.625 104.042Z",
    fill: "#D5FFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.583 74.25H63.4167C54.2084 74.25 47.1667 81.2917 47.1667 90.5V128.417C47.1667 137.625 54.2084 144.667 63.4167 144.667H117.583C126.792 144.667 133.833 137.625 133.833 128.417V90.5C133.833 81.2917 126.792 74.25 117.583 74.25ZM95.9167 110V117.583C95.9167 120.833 93.75 123 90.5 123C87.25 123 85.0834 120.833 85.0834 117.583V110C83.4584 108.375 82.375 106.208 82.375 104.042C82.375 99.7083 86.1667 95.9167 90.5 95.9167C94.8334 95.9167 98.625 99.7083 98.625 104.042C98.625 106.208 97.5417 108.375 95.9167 110Z",
    fill: "#0F9D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.b918fe52b3639c10607ab1723c437bdf.svg";
export { ForwardRef as ReactComponent };